var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pa-2 w100",attrs:{"max-width":"350px"}},[_c('div',{staticClass:"text-center"},[_c('img',{attrs:{"src":_vm.img}})]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }